import { AssetError } from 'store/error/types';
import { createAction } from 'typesafe-actions';

export const ERROR_FIRE_ACTION = createAction('@ERROR/FIRE_ACTION')();

export const CATCH_ERROR = createAction('@ERROR/CATCH_ERROR')<{
  error: Error | unknown;
  info?: Record<string, unknown>;
}>();

export const UPDATE_ASSET_ERROR = createAction('@ERROR/ASSET_ERROR')<
  Record<string, AssetError> | undefined
>();

export const SET_IS_UNAUTHORIZED = createAction('@ERROR/SET_IS_UNAUTHORIZED')();

export const SET_HAS_NETWORK_ERROR = createAction(
  '@ERROR/SET_HAS_NETWORK_ERROR',
)();
